// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2036":"b63ae87e088acd1c","2171":"4301e90b114a87b8","2739":"49faf4e05093176d","5133":"346db0be7b70b4d3","9235":"4d0f8605151f218f"}[chunkId] + ".js";
};